module.exports = __webpack_public_path__ + "static/media/22-5.02e3ddea.mp3";